import React, { Component } from "react";
import { Link } from 'react-router-dom';
const Portfolio_image = <img src="/assets/images/portfolio/fortnite-portfolio-unyverse-black-moon-escape-1.jpg" alt="Unyverse: Black Moon Escape" />;
const Portfolio_image2 = <img src="/assets/images/portfolio/fortnite-portfolio-hip-hop-pillars-2.jpg" alt="Hip-Hop Pillars" />;
const Portfolio_image3 = <img src="/assets/images/portfolio/fortnite-portfolio-dan-johns-music-1v1-1.jpg" alt="Dan Johns Music 1v1" />;


const FortnitePortfolioListContent = [
    {
        image: Portfolio_image,
        category: 'Roguelike',
        title: 'Unyverse: Black Moon Escape',
        description: 'An Afro-futuristic rogulelike adventure.',
        link: 'https://www.fortnite.com/@auzzzy/1943-0227-4413',
        playNowLink: 'https://www.fortnite.com/play/island/1943-0227-4413?lang=en-US'
    },
    {
        image: Portfolio_image2,
        category: 'Party Game',
        title: 'Hip-Hop Pillars',
        description: 'An action packed party game.',
        link: 'https://www.fortnite.com/@auzzzy/5959-3023-5215',
        playNowLink: 'https://www.fortnite.com/play/island/5959-3023-5215?lang=en-US'
    },
    {
        image: Portfolio_image3,
        category: '1v1 Map',
        title: 'Dan Johns Music 1v1',
        description: 'Hip-hop themed 1v1 map.',
        link: 'https://www.fortnite.com/@auzzzy/7344-4442-7381',
        playNowLink: 'https://www.fortnite.com/play/island/7344-4442-7381?lang=en-US'
    }
]

class FortnitePortfolioList extends Component{
    render(){
        const {column , stylevariation } = this.props;
        const list = FortnitePortfolioListContent.slice(0 , this.props.item);
        return(
            <React.Fragment> 
                {list.map((value , index) => (
                    <div className={`${column}`} key={index}>
                        <div className={`im_portfolio_no_gradient ${stylevariation}`}>
                            <div className="thumbnail_inner">
                                <div className="thumbnail">
                                    <Link to={value.link}>
                                        {value.image}
                                    </Link>    
                                </div>
                            </div>
                            <div className="content">
                                <div className="inner">
                                    {/* <div className="portfolio_heading">
                                        <div className="category_list">
                                            <Link to={value.link}>{value.category}</Link>
                                        </div>
                                        <h4 className="title"><Link to={value.link}>{value.title}</Link></h4>
                                    </div>
                                    <div className="portfolio_hover">
                                        <p>{value.description}</p>
                                    </div>*/}
                                </div>
                            </div>
                            <Link className="transparent_link" to={{ pathname: value.link }} target="_blank"></Link>
                        </div>
                        <div>
                            <p className="p--lite fortnite-card-description">{value.description}</p>
                        </div>
                        <div className="text-center fortnite-play-now-wrap">
                                    <a
                                        className="btn-default btn-small mt--20"
                                        href={value.playNowLink}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Play Now
                                    </a>
                                </div>
                    </div>
                ))}
            </React.Fragment>
        )
    }
}
export default FortnitePortfolioList;